module.exports = __webpack_public_path__ + "static/jfs-9bc767dce9e4c88b5896d04f31c58660.png";